module.exports = __webpack_public_path__ + "img/fundingResolutionLogo7.40b966b4.png";